import { useApp } from '../App';
import { useI18n } from '../i18n/index.jsx';

/**
 * CompanyGate — blocks access based on:
 * - requireContract: needs signed Cooperation Contract (for invoices/cash/withdrawals)
 * - requireWorkAuth: needs active Work Authorization (for legalization)
 * - allowWithout: show banner but allow access (for karta_pobytu prep)
 */
export default function CompanyGate({ children, requireContract = false, requireWorkAuth = false, allowWithout = false }) {
  const { currentCompany, hasWorkAuth, hasContract, setPage } = useApp();
  const { t } = useI18n();

  // No company at all
  if (!currentCompany) {
    return (
      <div className="page" style={{ textAlign: 'center', paddingTop: 60 }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🏢</div>
        <h2>{t('company_gate.select_company')}</h2>
        <p style={{ opacity: 0.7, marginBottom: 24 }}>
          {t('company_gate.select_desc')}
        </p>
        <button className="btn btn-primary" onClick={() => setPage('company_select')}>
          🏢 {t('company_gate.select_btn')}
        </button>
      </div>
    );
  }

  // Need contract but don't have one
  if (requireContract && !hasContract) {
    return (
      <div className="page" style={{ textAlign: 'center', paddingTop: 60 }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>📝</div>
        <h2>{t('company_gate.sign_contract')}</h2>
        <p style={{ opacity: 0.7, marginBottom: 8 }}>
          {t('company_gate.sign_desc')}
        </p>
        <p style={{ opacity: 0.5, fontSize: 13, marginBottom: 24 }}>
          {t('company_gate.sign_terms')}
        </p>
        <button className="btn btn-primary" onClick={() => setPage('contract_sign')}>
          ✍️ {t('company_gate.sign_btn')}
        </button>
      </div>
    );
  }

  // Need work authorization but don't have one
  if (requireWorkAuth && !hasWorkAuth) {
    return (
      <div className="page" style={{ textAlign: 'center', paddingTop: 60 }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🔒</div>
        <h2>{t('company_gate.work_auth_needed')}</h2>
        <p style={{ opacity: 0.7, marginBottom: 24 }}>
          {t('company_gate.work_auth_desc')}
        </p>
        <button className="btn btn-primary" onClick={() => setPage('work_permit')}>
          📋 {t('company_gate.request_permit')}
        </button>
      </div>
    );
  }

  // Allow without but show banner
  if (allowWithout && (!hasWorkAuth || !hasContract)) {
    return (
      <>
        {!hasWorkAuth && (
          <div className="banner banner-info" style={{ margin: '8px 16px' }}>
            ℹ️ {t('company_gate.work_auth_limited')}
          </div>
        )}
        {children}
      </>
    );
  }

  return children;
}
